var BookmarkAlbumTrackThumbnail      = require("app/ui/thumbnails/BookmarkAlbumTrackThumbnail"),
    BookmarkArtistThumbnail          = require("app/ui/thumbnails/BookmarkArtistThumbnail"),
    BookmarkAudioThumbnail           = require("app/ui/thumbnails/BookmarkAudioThumbnail"),
    BookmarkBookThumbnail            = require("app/ui/thumbnails/BookmarkBookThumbnail"),
    BookmarkBrandThumbnail           = require("app/ui/thumbnails/BookmarkBrandThumbnail"),
    BookmarkCategoryThumbnail        = require("app/ui/thumbnails/BookmarkCategoryThumbnail"),
    BookmarkEpisodeThumbnail         = require("app/ui/thumbnails/BookmarkEpisodeThumbnail"),
    BookmarkIssueThumbnail           = require("app/ui/thumbnails/BookmarkIssueThumbnail"),
    BookmarkMagazineThumbnail        = require("app/ui/thumbnails/BookmarkMagazineThumbnail"),
    BookmarkMusicAlbumThumbnail      = require("app/ui/thumbnails/BookmarkMusicAlbumThumbnail"),
    BookmarkPageThumbnail            = require("app/ui/thumbnails/BookmarkPageThumbnail"),
    BookmarkPhotoThumbnail           = require("app/ui/thumbnails/BookmarkPhotoThumbnail"),
    BookmarkPlaylistThumbnail        = require("app/ui/thumbnails/BookmarkPlaylistThumbnail"),
    BookmarkPodcastEpisodeThumbnail  = require("app/ui/thumbnails/BookmarkPodcastEpisodeThumbnail"),
    BookmarkPodcastThumbnail         = require("app/ui/thumbnails/BookmarkPodcastThumbnail"),
    BookmarkProductCategoryThumbnail = require("app/ui/thumbnails/BookmarkProductCategoryThumbnail"),
    BookmarkProductThumbnail         = require("app/ui/thumbnails/BookmarkProductThumbnail"),
    BookmarkSeriesThumbnail          = require("app/ui/thumbnails/BookmarkSeriesThumbnail"),
    BookmarkVideoThumbnail           = require("app/ui/thumbnails/BookmarkVideoThumbnail");

module.exports = function(bookmark) {
    switch (bookmark.media_item.type) {
        case "album_track":
            return BookmarkAlbumTrackThumbnail;
        case "artist_page":
            return BookmarkArtistThumbnail;
        case "audio":
            return BookmarkAudioThumbnail;
        case "book":
            return BookmarkBookThumbnail;
        case "brand":
            return BookmarkBrandThumbnail;
        case "category":
            return BookmarkCategoryThumbnail;
        case "episode":
            return BookmarkEpisodeThumbnail;
        case "issue":
            return BookmarkIssueThumbnail;
        case "magazine":
            return BookmarkMagazineThumbnail;
        case "music_album":
            return BookmarkMusicAlbumThumbnail;
        case "page":
            return BookmarkPageThumbnail;
        case "photo":
            return BookmarkPhotoThumbnail;
        case "playlist_page":
            return BookmarkPlaylistThumbnail;
        case "podcast_episode":
            return BookmarkPodcastEpisodeThumbnail;
        case "podcast":
            return BookmarkPodcastThumbnail;
        case "product_category":
            return BookmarkProductCategoryThumbnail;
        case "product":
            return BookmarkProductThumbnail;
        case "series":
            return BookmarkSeriesThumbnail;
        case "video":
            return BookmarkVideoThumbnail;
        default:
            return null;
    }
};
